// extracted by mini-css-extract-plugin
export default {"fitness-training":"fitness_fitness-training__LjNfC","section-head":"fitness_section-head__E2126","boxes-container":"fitness_boxes-container__fKx8r"};